<template>
  <ul class="controlUl">
    <v-keepWatch></v-keepWatch>
    <li v-if="checkPermission(['controlArea'])">
      <div @click="choiccontrolArea('管制区')">
        <img
          :src="
            controlAreaActive === '管制区'
              ? `/image/switchLayer/02.png`
              : `/image/switchLayer/01.png`
          "
          alt=""
        />
        <div>民航管制区</div>
      </div>
    </li>
    <li v-if="checkPermission(['controlRoom'])">
      <div @click="choicecontrolRoom('管制室')">
        <img
          :src="
            controlRoomActive === '管制室'
              ? `/image/switchLayer/12.png`
              : `/image/switchLayer/11.png`
          "
          alt=""
        />

        <div>机场管制区</div>
      </div>
    </li>

    <li v-if="checkPermission(['router'])">
      <div @click="choicerouter('航路')">
        <img
          :src="
            routerActive === '航路'
              ? `/image/switchLayer/22.png`
              : `/image/switchLayer/21.png`
          "
          alt=""
        />

        <div>航路</div>
      </div>
    </li>
    <li v-if="checkPermission(['line'])">
      <div @click="choiceline('航线')">
        <img
          :src="
            lineActive === '航线'
              ? `/image/switchLayer/32.png`
              : `/image/switchLayer/31.png`
          "
          alt=""
        />

        <div>航线</div>
      </div>
    </li>

    <li v-if="checkPermission(['lowAlt'])">
      <div @click="choicelowAlt('低空目视')">
        <img
          :src="
            lowAltActive === '低空目视'
              ? `/image/switchLayer/122.png`
              : `/image/switchLayer/121.png`
          "
          alt=""
        />

        <div>低空目视航线</div>
      </div>
    </li>

    <li v-if="checkPermission(['listbyposition'])">
      <div @click="choicelistbyposition('机场')">
        <img
          :src="
            listbypositionActive === '机场'
              ? `/image/switchLayer/62.png`
              : `/image/switchLayer/61.png`
          "
          alt=""
        />

        <div>机场</div>
      </div>
    </li>
    <li
      v-if="checkPermission(['dynamicairspace'])"
      @mouseenter="choicedynamicairspace('动态空域')"
      @mouseleave="choicedynamicairspace('')"
    >
      <img
        class="showIcon"
        src="/image/switchLayer/icon_nemu_Expand@2x.png"
        alt=""
      />
      <div>
        <img
          :src="
            dynamicairspaceActive === '动态空域'
              ? `/image/switchLayer/42.png`
              : `/image/switchLayer/41.png`
          "
          alt=""
        />

        <div>动态空域</div>

        <div v-if="dynamicairspaceActive" class="layerControlListDiv">
          <ul class="airpositionDataSourceUl">
            <!-- 添加点击事件 -->
            <li
              @click="switchAirspaceNew1('管制空域')"
              :class="
                AirspaceNew.CONTROL === true ? 'link featureactive' : 'link '
              "
            >
              <img
                src="image/switchLayer/服务循环管理.png"
                alt=""
                class="layercontrolistdivsimg"
              />
              管制空域
            </li>
            <li
              @click.stop="switchAirspaceNew1('监视空域')"
              :class="
                AirspaceNew.MONITOR === true ? 'link featureactive' : 'link '
              "
            >
              <img
                src="image/switchLayer/监视.png"
                alt=""
                class="layercontrolistdivsimg"
              />
              监视空域
            </li>
            <li
              class="link"
              @click.stop="switchAirspaceNew1('报告空域')"
              :class="
                AirspaceNew.REPORT === true ? 'link featureactive' : 'link '
              "
            >
              <img
                src="image/switchLayer/网站管理.png"
                alt=""
                class="layercontrolistdivsimg"
              />
              报告空域
            </li>
          </ul>
        </div>
      </div>
    </li>
    <li v-if="checkPermission(['customLine'])">
      <div @click="choiceCustomLine('自定义航线')">
        <img
          :src="
            customLineActive == '自定义航线'
              ? `/image/switchLayer/32.png`
              : `/image/switchLayer/31.png`
          "
          alt=""
        />

        <div>自定义航线</div>
      </div>
    </li>

    <li v-if="checkPermission(['customLayer'])">
      <div @click="choiceCustomLayer('自定义图层')">
        <img
          :src="
            customLayerActive == '自定义图层'
              ? `/image/switchLayer/72.png`
              : `/image/switchLayer/71.png`
          "
          alt=""
        />

        <div>自定义区域</div>
      </div>
    </li>

    <li
      v-if="checkPermission(['showWeather'])"
      @mouseenter="choiceItem(true)"
      @mouseleave="choiceItem('')"
    >
      <img
        class="showIcon"
        src="/image/switchLayer/icon_nemu_Expand@2x.png"
        alt=""
      />
      <div :class="showWeatherNav === true ? 'link featureactive' : 'link'">
        <img
          :src="
            showWeatherNav === true
              ? `/image/switchLayer/82.png`
              : `/image/switchLayer/81.png`
          "
          alt=""
        />

        <div>气象</div>

        <!-- 气象图层 -->
        <v-MeteorologicalLayer
          v-show="showWeatherNav"
          class="layerControlListDiv"
        ></v-MeteorologicalLayer>
      </div>
    </li>

    <li v-show="checkPermission(['keepWatch'])">
      <div @click="choiceAdsb('监视')" class="adsb">
        <img
          :src="
            adsbActive === '监视'
              ? `/image/switchLayer/52.png`
              : `/image/switchLayer/51.png`
          "
          alt=""
        />

        <div>监视</div>
      </div>
    </li>

    <li
      v-if="checkPermission(['Air'])"
      @mouseenter="choiceAir('航空器')"
      @mouseleave="choiceAir('')"
    >
      <img
        class="showIcon"
        src="/image/switchLayer/icon_nemu_Expand@2x.png"
        alt=""
      />
      <div>
        <img
          :src="
            AirActive === '航空器'
              ? `/image/switchLayer/112.png`
              : `/image/switchLayer/111.png`
          "
          alt=""
        />

        <div>航空器</div>

        <v-swichWatchAir
          v-if="AirActive === '航空器'"
          class="layerControlListDiv"
          :Air="Air"
        ></v-swichWatchAir>
      </div>
    </li>

    <li
      v-if="checkPermission(['showPlan'])"
      @mouseenter="choicePlanRegion('计划区域')"
      @mouseleave="choicePlanRegion('')"
    >
      <img
        class="showIcon"
        src="/image/switchLayer/icon_nemu_Expand@2x.png"
        alt=""
      />
      <div>
        <img
          :src="
            PlanRegionActive === '计划区域'
              ? `/image/switchLayer/142.png`
              : `/image/switchLayer/141.png`
          "
          alt=""
        />

        <div>计划区域</div>

        <v-swichPlanRegion
          v-show="PlanRegionActive === '计划区域'"
          class="layerControlListDiv"
          :PlanRegion="PlanRegion"
        ></v-swichPlanRegion>
      </div>
    </li>

    <li v-if="checkPermission(['station'])">
      <div @click="choiceStation('地面站')">
        <img
          :src="
            StationActive === '地面站'
              ? `/image/switchLayer/132.png`
              : `/image/switchLayer/131.png`
          "
          alt=""
        />

        <div>地面站</div>
      </div>
    </li>

    <li v-if="checkPermission(['ranging'])">
      <div @click="choiceranging('测距')">
        <v-measure ref="measure"></v-measure>

        <img
          :src="
            rangingActive === '测距'
              ? `/image/switchLayer/102.png`
              : `/image/switchLayer/101.png`
          "
          alt=""
        />

        <div>测距</div>
      </div>
    </li>
  </ul>
</template>

<script>
import { ws, yunxiangHost } from "@/utils/config";
import drawLayer from "@/mixin/drawLayer";
import { mapGetters, mapActions, mapMutations } from "vuex";

import checkPermission from "@/utils/permission.js";

import {
  dynamicairspace,
  dynamicpolygon,
  customRouteList,
  customRouteListAll,
  listbyposition,
  airlinelist,
  airroutelist,
  monitoringAreaList,
  monitoringRoundList,
  lowaltituderoutelist,
  HNJCGZQmonitoringAreaList,
  getBranchAirportMsg,
} from "../request/api";

export default {
  mixins: [drawLayer],
  data() {
    return {
      showWeatherNav: false,
      AirspaceNew: {
        // 添加
        CONTROL: false,
        MONITOR: false,
        REPORT: false,
        LIMIT: false,
      },
      adsbActive: null, //监视
      rangingActive: null, //测距
      dynamicairspaceActive: false,
      listbypositionActive: null,
      lineActive: null,
      routerActive: null,
      controlAreaActive: null,
      controlRoomActive: null,
      lowAltActive: null,
      AirActive: null,
      alarmActive: null,
      customLayerActive: null,
      customLineActive: null,
      StationActive: "地面站",
      PlanRegionActive: null,

      choiceActiveName: null,

      //子组件初始状态存这里
      Air: {
        General: true,
        Transport: true,
        UAV: true,
        Terminal: true,
      },

      PlanRegion: {
        todayPlan: true,
        towPlan: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      cloudMap: "meteorologicalMap/cloudMap",
      adsbMap: "meteorologicalMap/adsbMap",
      newMap: "meteorologicalMap/newMap",
      alarmMap: "meteorologicalMap/alarmMap",
      boundMap: "meteorologicalMap/boundMap",
      routerMap: "meteorologicalMap/routerMap",
      controlMap: "meteorologicalMap/controlMap",
      lowAltMap: "meteorologicalMap/lowAltMap",
      meteoToken: "meteoToken",
      userId: "userId",
      type: "type",
      currentMap: "switchMap/currentMap",
      alarmHeight: "swichLayer/alarmHeight",
      areaMap: "meteorologicalMap/areaMap",
    }),
  },
  mounted() {
    this.changeRoles(this.$route.meta.permission.switchLayer);
    if (checkPermission(["customLine"])) this.choiceCustomLine("自定义航线");
  },

  methods: {
    checkPermission,
    ...mapActions({
      startDataDrawAction: "drawMap/startDataDrawAction",
      stopDrawAction: "drawMap/stopDrawAction",
    }),
    ...mapMutations({
      changeRoles: "swichLayer/changeRoles",
      changeGeneralNowNumber: "swichLayer/changeGeneralNowNumber",
      changeTransportNowNumber: "swichLayer/changeTransportNowNumber",
      changeAirNowNumber: "swichLayer/changeAirNowNumber",
      changeGeneralNowList: "swichLayer/changeGeneralNowList",
      initPlanshow: "swichLayer/initPlanshow",
      changeShowPlanList: "swichLayer/changeShowPlanList",
      startRealDataDraw: "drawMap/startRealDataDraw",
      stopRealDraw: "drawMap/stopRealDraw",
    }),
    closeAll() {
      this.delDynamicairspace();
      this.delCustomRouteList();
      this.delListbyposition();
      this.closeLine();
      this.closerouter();
      this.closeControlArea();
      this.closeControlRoom();
      this.closelowAlt();
      this.closeCustomLayer();
      this.closeCustomLine();
      this.delDynamicpolygon("all");
    },
    //监视
    choiceAdsb(item) {
      if (!this.adsbActive) {
        this.adsbActive = item;
        this.$eventBus.$emit("openAdsbData");
      } else {
        this.adsbActive = null;
        this.$eventBus.$emit("closeWebsocket");
      }
    },
    //动态空域
    choicedynamicairspace(item) {
      if (!this.dynamicairspaceActive) {
        this.dynamicairspaceActive = item;
      } else {
        this.dynamicairspaceActive = null;
      }
    },
    //测距
    choiceranging(item) {
      if (!this.rangingActive) {
        this.rangingActive = item;

        this.$refs.measure.measure();
      } else {
        this.rangingActive = null;
        this.$refs.measure.measure();
      }
    },
    //机场
    choicelistbyposition(item) {
      if (!this.listbypositionActive) {
        this.listbypositionActive = item;
        this.getListbyposition();
      } else {
        this.listbypositionActive = null;
        this.delListbyposition();
      }
    },

    //航线
    choiceline(item) {
      if (!this.lineActive) {
        this.lineActive = item;
        this.openLine();
      } else {
        this.lineActive = null;
        this.closeLine();
      }
    },

    //航路
    choicerouter(item) {
      if (!this.routerActive) {
        this.routerActive = item;
        this.openrouter();
      } else {
        this.routerActive = null;
        this.closerouter();
      }
    },

    //管制区
    choiccontrolArea(item) {
      if (!this.controlAreaActive) {
        this.controlAreaActive = item;
        this.openControlArea();
      } else {
        this.controlAreaActive = null;
        this.closeControlArea();
      }
    },
    //管制室
    choicecontrolRoom(item) {
      if (!this.controlRoomActive) {
        this.controlRoomActive = item;
        this.openControlRoom();
      } else {
        this.controlRoomActive = null;
        this.closeControlRoom();
      }
    },
    //低空目视
    choicelowAlt(item) {
      if (!this.lowAltActive) {
        this.lowAltActive = item;
        this.openlowAlt();
      } else {
        this.lowAltActive = null;
        this.closelowAlt();
      }
    },
    //气象
    choiceItem(item) {
      if (!this.showWeatherNav) {
        this.showWeatherNav = item;
      } else {
        this.showWeatherNav = null;
      }
    },

    choiceAir(item) {
      if (!this.AirActive) {
        this.AirActive = item;
      } else {
        this.AirActive = null;
      }
    },
    choicePlanRegion(item) {
      if (!this.PlanRegionActive) {
        this.PlanRegionActive = item;
      } else {
        this.PlanRegionActive = null;
      }
    },

    choiceStation(item) {
      if (!this.StationActive) {
        this.StationActive = item;
        this.openStation();
      } else {
        this.StationActive = null;
        this.closeStation();
      }
    },

    choiceCustomLayer(item) {
      if (!this.customLayerActive) {
        this.customLayerActive = item;
        this.openCustomLayer();
      } else {
        this.customLayerActive = null;
        this.closeCustomLayer();
      }
    },
    choiceCustomLine(item) {
      if (!this.customLineActive) {
        this.customLineActive = item;
        this.openCustomLine();
      } else {
        this.customLineActive = null;
        this.closeCustomLine();
      }
    },
    async openCustomLine() {
      let res = await customRouteListAll({ type: "jfss" });
      res.forEach((element) => {
        let latlngs = [];
        element.points.forEach((point) => {
          let latlng = [point.la, point.lo];
          latlngs.push(latlng);
        });

        var drawLayer = L.polyline(latlngs, {
          pane: "poly",
          color: "#57c9f3",
          weight: 4,
        }).addTo(this.alarmMap.customLine);
      });
    },
    closeCustomLine() {
      this.alarmMap.customLine.clearLayers();
    },
    async openCustomLayer() {
      let res = await monitoringAreaList({ type: "NOFLY" });

      res.forEach((element) => {
        let latlngs = [];
        element.points.forEach((point) => {
          let latlng = [point.la, point.lo];
          latlngs.push(latlng);
        });

        var drawLayer = L.polygon(latlngs, {
          pane: "poly",
          color: "red",
        }).addTo(this.alarmMap.NOFLYGroup);

        latlngs.push(latlngs[0]);

        var polygonTurf = this.$turf.polygon([latlngs]);
        var center = this.$turf.centerOfMass(polygonTurf).geometry.coordinates;

        var c = L.circleMarker(center, {
          radius: 0,
          opacity: 0,
        })
          .bindTooltip(`<p>${element.title}</p>`, {
            pane: "util",
            permanent: true,
            direction: "center",
            offset: [0, 0],
            className: "DistanceTooltip",
          })
          .addTo(this.alarmMap.NOFLYGroup);
      });
    },

    closeCustomLayer() {
      this.alarmMap.NOFLYGroup.clearLayers();
    },

    //动态空域
    switchAirspaceNew1(item) {
      switch (item) {
        case "管制空域":
          if (!this.AirspaceNew.CONTROL) {
            this.AirspaceNew.CONTROL = true;
            this.getGeneralcompany("gz");
          } else {
            this.AirspaceNew.CONTROL = false;
            this.delDynamicpolygon("CONTROL");
          }
          break;
        case "监视空域":
          if (!this.AirspaceNew.MONITOR) {
            this.AirspaceNew.MONITOR = true;
            this.getGeneralcompany("js");
          } else {
            this.AirspaceNew.MONITOR = false;
            this.delDynamicpolygon("MONITOR");
          }
          break;
        case "报告空域":
          if (!this.AirspaceNew.REPORT) {
            this.AirspaceNew.REPORT = true;
            this.getGeneralcompany("bg");
          } else {
            this.AirspaceNew.REPORT = false;
            this.delDynamicpolygon("REPORT");
          }
          break;
        default:
          break;
      }
    },

    closelowAlt() {
      this.lowAltMap.lowAltGroup.clearLayers();
    },

    openStation() {
      this.$eventBus.$emit("showAllStation");
    },
    closeStation() {
      this.$eventBus.$emit("hideAllStation");
    },
    fn1() {
      let str = `
N26°03′50″E109°48′06″N25°31′36″E109°40′16″#
N26°28′23″E110°52′35″N25°16′46″E110°18′49″#
N26°03′50″E109°48′06″N25°44′27″E108°42′15″#
N25°11′30″E111°24′46″N24°53′22″E111°19′48″#
N25°18′50″E112°33′12″N24°50′24″E112°31′59″#
N25°24′00″E112°54′16″N25°05′54″E113°33′56″#
N26°01′57″E113°56′16″N25°55′40″E114°32′56″#
N26°53′52″E113°57′11″N26°53′52″E114°32′56″#
N27°50′04″E113°43′05″N27°45′45″E114°23′23″#
N28°34′48″E113°43′14″N28°34′48″E114°23′23″#
N29°13′57″E113°37′24″N29°04′54″E114°23′23″#
N29°13′57″E113°37′24″N29°44′44″E114°01′57″#
N29°25′02″E112°24′11″N30°04′28″E112°24′11″#
N29°36′49″E111°26′45″N30°04′28″E111°26′45″#
N29°34′41″E110°26′25″N30°00′13″E110°07′37″#
N29°29′37″E109°28′52″N29°29′37″E108°42′15″#
N28°24′50″E109°40′18″N28°24′50″E108°42′15″#
N28°02′06″E109°41′06″N27°41′48″E108°42′15″#
N27°10′32″E110°01′58″N26°46′05″E108°42′15″`;
      let arr1 = str.split("#");
      let arr2 = [];
      arr1.forEach((item) => {
        let substring1 = item.substring(2, 10);
        let substring2 = item.substring(12, 12 + 9);
        let substring3 = item.substring(23, 23 + 9);
        let substring4 = item.substring(24 + 9, 24 + 9 + 9);

        arr2.push([
          {
            lo: substring1,
            la: substring2,
          },
          {
            lo: substring3,
            la: substring4,
          },
        ]);
      });
    },

    fn2(dataArr) {
      let newArr = [];

      dataArr.forEach((item) => {
        let arr = item.split("#");

        let obj = {
          title: arr[0],
          lo: arr[2],
          la: arr[1],
        };
        newArr.push(obj);
      });

      return newArr;
    },
    //低空目视
    async openlowAlt() {
      let labelArr = this.fn2(ExtraDataArr);
      let lowAltPiontArr = this.fn2(lowAltPointArr);

      lowAltPiontArr.forEach((item) => {
        item.la = Dms2D(item.la);
        item.lo = Dms2D(item.lo);

        L.circleMarker([item.la, item.lo], {
          radius: 5,
          color: "rgba(255,0,0,0.4)",
          fillOpacity: 0,
        }).addTo(this.lowAltMap.lowAltGroup);
      });

      labelArr.forEach((item) => {
        item.la = Dms2D(item.la);
        item.lo = Dms2D(item.lo);

        var myIcon = L.divIcon({
          html: item.title,
          className: "lowAltLabelTooltip",
          iconAnchor: [100, 20],
        });
        L.marker([item.la, item.lo], { pane: "util", icon: myIcon }).addTo(
          this.lowAltMap.lowAltGroup
        );
      });

      var xhr = new XMLHttpRequest();

      xhr.open("GET", "/static/json/GrayLine_HN.json", false);

      xhr.onload = (res) => {
        var arr = JSON.parse(res.currentTarget.response);

        arr.forEach((item) => {
          item[0].la = Dms2D(item[0].la);
          item[0].lo = Dms2D(item[0].lo);
          item[1].la = Dms2D(item[1].la);
          item[1].lo = Dms2D(item[1].lo);

          var drawLayer = new L.Polyline(
            [
              [item[0].lo, item[0].la],
              [item[1].lo, item[1].la],
            ],
            {
              pane: "t_plane",
              color: "rgba(216, 224, 235,0.6)",
              dashArray: [15, 20],
              weight: 6,
            }
          ).addTo(this.lowAltMap.lowAltGroup);
        });
      };

      xhr.send();

      let res = await lowaltituderoutelist();

      res.forEach((item) => {
        let latlngs = [];
        item.points.forEach((i) => {
          let latlng = [i.la, i.lo];
          latlngs.push(latlng);
        });
        if (item.type === "干线") {
          var drawLayer = new L.Polyline(latlngs, {
            pane: "t_plane",
            color: "rgba(1, 147, 254,0.7)",
            weight: 6,
          })
            .bindPopup(
              ` 
            <p>区域名称：${item.title}}</p>
              `
            )
            .addTo(this.lowAltMap.lowAltGroup);
        } else if (item.type === "支线") {
          var drawLayer = new L.Polyline(latlngs, {
            pane: "t_plane",
            color: "rgba(1, 147, 254,0.7)",
            dashArray: [15, 20],
            weight: 6,
          })
            .bindPopup(
              ` 
            <p>区域名称：${item.title}</p>
              `
            )
            .addTo(this.lowAltMap.lowAltGroup);
        } else if (item.type === "通线") {
          var drawLayer = new L.Polyline(latlngs, {
            pane: "t_plane",
            color: "rgba(1, 147, 254,0.7)",
            dashArray: [15, 20],
            weight: 6,
          })
            .bindPopup(
              ` 
            <p>区域名称：${item.title}</p>
              `
            )
            .addTo(this.lowAltMap.lowAltGroup);
        } else if (item.type === "环线") {
          var drawLayer = new L.Polyline(latlngs, {
            pane: "t_plane",
            color: "rgba(1, 147, 254,0.7)",
            weight: 6,
          })
            .bindPopup(
              ` 
            <p>区域名称：${item.title}</p>
              `
            )
            .addTo(this.lowAltMap.lowAltGroup);
        } else {
          var drawLayer = new L.Polyline(latlngs, {
            pane: "t_plane",
            color: "rgba(1, 147, 254,0.7)",
            weight: 6,
          })
            .bindPopup(
              ` 
            <p>区域名称：${item.title}</p>
              `
            )
            .addTo(this.lowAltMap.lowAltGroup);
        }
      });
    },

    closeControlRoom() {
      this.controlMap.ControlRoomGroup.clearLayers();
    },

    async openControlRoom() {
      let res = await HNJCGZQmonitoringAreaList({ type: "HNJCGZQ" });
      res.forEach((item) => {
        let latlngs = [];
        item.points.forEach((i) => {
          let latlng = [i.la, i.lo];
          latlngs.push(latlng);
        });

        var drawLayer = L.polygon(latlngs, {
          pane: "poly",
          fillOpacity: 0,
          color: "red",
          weight: 2,
          opacity: 1,
        })
          .bindPopup(
            ` 
            <p>区域名称：${item.title}</p>
            <p>最小高度：${item.minheight}</p>
            <p>最大高度：${item.maxheight}</p>
          `,
            {
              pane: "util",
            }
          )
          .addTo(this.controlMap.ControlRoomGroup);
      });
    },

    closeControlArea() {
      this.controlMap.controlGroup.clearLayers();
    },

    //添加管制区
    async openControlArea() {
      let res = await getBranchAirportMsg();

      res.polygon.forEach((item) => {
        let latlngs = [];
        item.points.forEach((i) => {
          let latlng = [i.la, i.lo];
          latlngs.push(latlng);
        });

        var drawLayer = L.polygon(latlngs, {
          pane: "poly",
          fillOpacity: 0,
          color: item.strokecolor,
          weight: 2,
          opacity: 1,
        })
          .bindPopup(
            ` 
            <p>区域名称：${item.title}</p>
            <p>最小高度：${item.minheight}</p>
            <p>最大高度：${item.maxheight}</p>
            `,
            {
              pane: "util",
            }
          )
          .addTo(this.controlMap.controlGroup);
      });

      res.round.forEach((item) => {
        let radius = item.radius * 1000;
        var drawLayer = L.circle([item.la, item.lo], {
          pane: "poly",
          radius,
          fillOpacity: 0,
          color: item.strokecolor,
          weight: 2,
          opacity: 1,
        })
          .bindPopup(`<p>区域名称：${item.title}</p>`, {
            pane: "util",
          })
          .addTo(this.controlMap.controlGroup);
      });
    },
    closeLine() {
      this.routerMap.lineGroup.clearLayers();
    },
    closerouter() {
      this.routerMap.routerGroup.clearLayers();
    },
    //航线
    async openLine() {
      function unique(arr) {
        let newobj = {};
        arr = arr.reduce((preVal, curVal) => {
          newobj[curVal[2]] ? "" : (newobj[curVal[2]] = preVal.push(curVal));
          return preVal;
        }, []);
        return arr;
      }

      let res = await airlinelist();

      const ciLayer = L.canvasMarkerLayer({
        pane: "util",
        userDrawFunc: function (layer, marker, pointPos, size) {
          size = [marker.title.length * 5, 24];
          const ctx = layer._context;
          ctx.beginPath();
          ctx.fillStyle = "rgba(0,0,0,0.2)";
          ctx.fillRect(
            pointPos.x - size[0] / 2,
            pointPos.y - size[1] - 5,
            size[0],
            size[1]
          );
          ctx.font = "14px cursive";
          ctx.fillStyle = "rgba(255,255,255,0.7)";
          ctx.fillText(
            marker.title,
            pointPos.x - size[0] / 2,
            pointPos.y - size[1] / 2
          );
          ctx.textAlign = "center";
          ctx.closePath();
        },
      }).addTo(this.routerMap.lineGroup);

      let pointArr = [];
      res.forEach((item) => {
        var latlngs = [];
        item.dataList.forEach((i) => {
          latlngs.push([i[0], i[1]]);
          pointArr.push(i);
        });

        var polyline = L.polyline(latlngs, {
          color: "rgba(18, 150, 219, 0.5)",
          weight: 4,
          pane: "t_plane",
        }).addTo(this.routerMap.lineGroup);
      });

      let markers = [];
      pointArr = unique(pointArr);
      pointArr.forEach((i) => {
        var marker = L.marker([i[0], i[1]], {
          icon: L.icon({
            iconUrl: "/image/beacon.png",
            iconSize: [10, 10],
          }),
        });
        marker.title = i[2];
        markers.push(marker);
      });
      ciLayer.addLayers(markers);
    },
    //航路
    async openrouter() {
      let routerRes = await airroutelist();
      routerRes.forEach((item) => {
        var latlngs = [];

        item.dataList.forEach((i) => {
          latlngs.push([i[0], i[1]]);

          var c = L.circleMarker([i[0], i[1]], {
            radius: 3,
          })
            .bindTooltip(i[2], {
              permanent: true,
              offset: [0, 5],
              pane: "util",
              direction: "top",
              className: "PointTooltip",
            })
            .addTo(this.routerMap.routerGroup);
        });

        L.polyline(latlngs, {
          color: "rgba(18, 150, 219, 0.5)",
          weight: 10,
          pane: "t_plane",
        }).addTo(this.routerMap.routerGroup);
      });
    },

    publishStatus(status) {
      if (status === 0) {
        return "未发布";
      } else if (status === 1) {
        return "已发布";
      }
    },
    getTitle(status) {
      if (status === 0) {
        return "管制";
      } else if (status === 1) {
        return "报告";
      } else if (status === 2) {
        return "监视";
      }
    },
    tDColor(status) {
      if (status === 0) {
        return "#c18c2a";
      } else if (status === 1) {
        return "#10631d";
      } else if (status === 2) {
        return "#e4e74f";
      }
    },

    // 新增函数动态空域
    async getGeneralcompany(type) {
      let res = await dynamicairspace();
      this.AirspaceList = res;

      if (type == "gz") {
        this.AirspaceList.forEach((item) => {
          if (item.status === 0) {
            let latlngs = [];
            item.airspacerange.points.forEach((i) => {
              let latlng = [i.la, i.lo];
              latlngs.push(latlng);
            });
            let title = this.getTitle(item.status);
            let color = this.tDColor(item.status);
            var drawLayer = L.polygon(latlngs, {
              pane: "poly",
              fillOpacity: 0.2,
              fillColor: color,
              color: color,
              weight: 1,
              opacity: 0.8,
            })
              .bindPopup(
                `
            <p>区域代码：${item.code}</p>
            <p>当前状态：${title}</p>
            <p>最大高度：${item.alttop}米</p>
                            <p>服务高度：${
                              item.serverheight ? item.serverheight : "--"
                            }米</p>
          `,
                {
                  pane: "util",
                }
              )
              .addTo(this.areaMap.CONTROLGroup);
          }
        });
      }
      if (type == "js") {
        this.AirspaceList.forEach((item) => {
          if (item.status === 2) {
            let latlngs = [];
            item.airspacerange.points.forEach((i) => {
              let latlng = [i.la, i.lo];
              latlngs.push(latlng);
            });
            let title = this.getTitle(item.status);
            let color = this.tDColor(item.status);
            var drawLayer = L.polygon(latlngs, {
              pane: "poly",
              fillOpacity: 0.2,
              fillColor: color,
              color: color,
              weight: 1,
              opacity: 0.8,
            })
              .bindPopup(
                ` 
            <p>区域名称：${item.name}</p>
            <p>区域代码：${item.code}</p>
            <p>最大高度：${item.alttop}米</p>
                            <p>服务高度：${
                              item.serverheight ? item.serverheight : "--"
                            }米</p>
          `,
                {
                  pane: "util",
                }
              )
              .addTo(this.areaMap.MONITORGroup);
          }
        });
      }
      if (type == "bg") {
        this.AirspaceList.forEach((item) => {
          if (item.status === 1) {
            let latlngs = [];
            item.airspacerange.points.forEach((i) => {
              let latlng = [i.la, i.lo];
              latlngs.push(latlng);
            });
            let title = this.getTitle(item.status);
            let color = this.tDColor(item.status);
            var drawLayer = L.polygon(latlngs, {
              pane: "poly",
              fillOpacity: 0.5,
              fillColor: color,
              color: color,
              weight: 2,
              opacity: item.airspacerange.opacity,
            })
              .bindPopup(
                ` 
            <p>区域名称：${item.name}</p>
            <p>区域代码：${item.code}</p>
            <p>最大高度：${item.alttop}米</p>
                            <p>服务高度：${
                              item.serverheight ? item.serverheight : "--"
                            }米</p>
          `,
                {
                  pane: "util",
                }
              )
              .addTo(this.areaMap.REPORTGroup);
          }
        });
      }
    },
    // 清除动态空域
    delDynamicairspace() {
      this.newMap.newGroup.clearLayers();
    },
    // 清除机场
    delListbyposition() {
      this.newMap.positionGroup.clearLayers();
    },
    // 清除航线
    delCustomRouteList() {
      this.newMap.CustomGroup.clearLayers();
    },

    //清除告警
    delDynamicpolygon(type) {
      if (type === "all") {
        // 添加
        this.areaMap.CONTROLGroup.clearLayers();
        this.areaMap.MONITORGroup.clearLayers();
        this.areaMap.REPORTGroup.clearLayers();
      } else if (type === "CONTROL") {
        this.areaMap.CONTROLGroup.clearLayers();
      } else if (type === "MONITOR") {
        this.areaMap.MONITORGroup.clearLayers();
      } else if (type === "REPORT") {
        this.areaMap.REPORTGroup.clearLayers();
      }
    },

    //告警空域
    async getDynamicpolygon(type) {
      let res = await dynamicpolygon();
      let data = res.page.list.filter((item) => {
        return item.type === type;
      });

      data.forEach((item) => {
        let latlngs = [];
        item.points.forEach((i) => {
          let latlng = [i.la, i.lo];
          latlngs.push(latlng);
        });

        var drawLayer = L.polygon(latlngs, {
          fillOpacity: item.fillopacity,
          fillColor: item.fillcolor,
          color: item.strokecolor,
          weight: item.strokeweight,
          opacity: item.strokeopacity,
        }).bindPopup(
          ` 
            <p>区域名称：${item.title}</p>
            <p>区域类型：${item.type}</p>
            <p>最小高度：${item.minheight}</p>
            <p>最大高度：${item.maxheight}</p>
          `
        );
        if (type === "ORDINARY") {
          drawLayer.addTo(this.alarmMap.ORDINARYGroup);
        } else if (type === "LIMITED") {
          drawLayer.addTo(this.alarmMap.LIMITEDGroup);
        } else if (type === "NOFLY") {
          drawLayer.addTo(this.alarmMap.NOFLYGroup);
        } else if (type === "CONFLICT") {
          drawLayer.addTo(this.alarmMap.CONFLICTGroup);
        }
      });
    },

    //航线
    async getCustomRouteList() {
      let res = await customRouteList({ type: "custom" });
      res.page.list.forEach((item) => {
        let latlngs = [];
        item.points.forEach((i) => {
          let latlng = [i.la, i.lo];
          latlngs.push(latlng);
        });
        if (item.opacity) {
          new L.Polyline(latlngs, {
            color: "rgba(18, 150, 219,0.7)",
            weight: item.strokeweight,
            opacity: item.strokeopacity,
            pane: "t_plane",
          }).addTo(this.newMap.CustomGroup);
        } else {
          new L.Polyline(latlngs, {
            color: "rgba(18, 150, 219,0.7)",
            weight: item.strokeweight,
            dashArray: [10, 20],
            opacity: item.strokeopacity,
            pane: "t_plane",
          }).addTo(this.newMap.CustomGroup);
        }
      });
    },
    //机场
    async getListbyposition() {
      let res = await listbyposition({ province: "湖南" });

      var icon;

      let arr = [];

      res.forEach((item) => {
        item.height = AirportFruitHeight[item.name];
        item.name = AirportFruit[item.name];

        if (item.airporttype == 1) {
          icon = L.icon({
            iconUrl: "/image/home/bottom/通用机场.png",
            iconSize: [30, 30],
          });
        } else {
          icon = L.icon({
            iconUrl: "/image/home/bottom/跑道机场.png",
            iconSize: [30, 30],
          });
        }
        var marker = L.marker([item.la, item.lo], {
          icon: icon,
          pane: "airport",
        })
          .bindTooltip(`<p>${item.name}</p>`, {
            pane: "util",
            permanent: true,
            direction: "top",
            offset: [0, -10],
            className: "DistanceTooltip",
          })

          .addTo(this.newMap.positionGroup);
        marker.item = item;
        arr.push(marker);
      });

      map.on("click", () => {
        arr.forEach((mar) => {
          mar.setTooltipContent(`
          <p>${mar.item.name}</p>
          `);
        });
      });

      arr.forEach((marker) => {
        marker.on("click", () => {
          arr.forEach((mar) => {
            mar.setTooltipContent(`
          <p>${mar.item.name}</p>
          `);
          });

          marker.setTooltipContent(`
          <p>${marker.item.name}</p>
          <p>经度:${
            ToDegrees(marker.item.lo)[0] +
            "°" +
            ToDegrees(marker.item.lo)[1] +
            "′" +
            ToDegrees(marker.item.lo)[2] +
            "′′" +
            "E"
          }</p>
          <p>纬度:${
            ToDegrees(marker.item.la)[0] +
            "°" +
            ToDegrees(marker.item.la)[1] +
            "′" +
            ToDegrees(marker.item.la)[2] +
            "′′" +
            "E"
          }</p>  
          <p>海拔:${marker.item.height}m</p>  
          <p>频率:${marker.item.frequency}</p>  
          `);
        });
      });
    },
  },
  beforeDestroy() {
    this.closeAll();
  },
};
</script>

<style lang="less" scoped>
.controlUl {
  position: relative;
  li {
    margin-bottom: 3px;
    position: relative;
    div {
      display: flex;
      align-items: center;
      cursor: pointer;
      color: #c3d3ea;

      img {
        width: 35px;
        height: 35px;
      }
    }
  }
}

.link {
  cursor: pointer;
}
.link:hover {
  color: #2cfdff;
}

.featureactive {
  color: #2cfdff !important;
}

.layerControlListDiv {
  //二级菜单
  background: linear-gradient(
    0deg,
    rgba(27, 50, 81, 0.88) 0%,
    rgba(28, 44, 59, 0.88) 99%
  );

  color: #c3d3ea;
  width: 120px;
  position: absolute;
  right: 138px;
  top: 0px;
}

.layercontrolistdivsimg {
  width: 20px !important;
  height: 20px !important;
}

.airpositionDataSourceUl li {
  height: 29px;
  padding-left: 10px;
}

.showIcon {
  position: absolute;
  z-index: -1;
  left: -20px;
  top: -1.5px;
  width: 40px;
  height: 40px;
}
</style>